var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/model/treeModel.ts";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { combine } from 'effector';
import { isNotEmpty } from '@gmini/utils';
import { getNode } from "../../../classifier-service";
import { isReferenceNode } from "../../../classifier-service/Node";
import { createChildTree } from "../createTree";
export function createDependencyTreeModel(_ref) {
  var nodes$ = _ref.nodes$,
      _currentEntity$ = _ref.currentEntity$;
  var currentEntity$ = _currentEntity$; // Костыль для typescript
  // TODO: убрать когда правильно заработают сторы, без этого не срабатывает второй combine для flatTree$

  combine({
    ɔ: [{
      nodes: nodes$,
      currentEntity: currentEntity$
    }],
    config: {
      sid: "-hxqwy3"
    }
  });
  var flatTree$ = combine({
    ɔ: [{
      nodes: nodes$,
      currentEntity: currentEntity$
    }, function (_ref2) {
      var nodes = _ref2.nodes,
          currentEntity = _ref2.currentEntity;

      if (!currentEntity || !currentEntity.sourceClassifiers.length) {
        return [];
      }

      var sourceClassifiers = currentEntity.sourceClassifiers.map(function (ref) {
        return getNode(nodes, ref);
      }).filter(isNotEmpty).filter(function (src) {
        var _currentEntity$assemb;

        var modelRefRef = src.children[0];

        if (!modelRefRef) {
          return true;
        }

        var modelRef = getNode(nodes, modelRefRef); // Костыль: убираем из зависимостей "суррогатную" модель

        if (modelRef && isReferenceNode(modelRef) && currentEntity.type === 'AssemblyClassifierNode' && ((_currentEntity$assemb = currentEntity.assemblyModelRef) === null || _currentEntity$assemb === void 0 ? void 0 : _currentEntity$assemb.element.id) === modelRef.element.id) {
          return false;
        }

        return true;
      }).flatMap(function (baseOrUserClassifier) {
        switch (baseOrUserClassifier.type) {
          case 'AssemblyClassifierNode':
          case 'AnonymousClassifierNode':
          case 'UserClassifierNode':
            {
              return [baseOrUserClassifier];
            }

          case 'BaseClassifierNode':
            {
              return baseOrUserClassifier.children.filter(function (child) {
                var node = getNode(nodes, child); //gs-313 проверка что версия референса в сторе нод соответствует версии базового классификатора

                return (node === null || node === void 0 ? void 0 : node.parentClassifierVersion) === baseOrUserClassifier.version;
              });
            }
        }
      }).map(function (model) {
        return getNode(nodes, model);
      }).filter(isNotEmpty);
      var flatTree = createChildTree({
        nodes: nodes,
        rootNodeRefs: sourceClassifiers
      });
      return flatTree;
    }],
    config: {
      name: "flatTree$",
      sid: "7grpx9"
    }
  });
  return {
    flatTree$: flatTree$
  };
}